/**
 * URI to hand the IdP as `redirect_uri`, so the user lands back where they started. `/logout` is
 * excluded: it is the `post_logout_redirect_uri`, and when it is served by the SPA (the Vite dev
 * server — in a deployment the Go router owns `/logout`) `App` immediately `<Redirect to="/" />`s
 * away from it. That history.replace runs in the layout phase, i.e. before `AuthProvider`'s effect
 * reads `?code`/`?state`, so a callback landing on `/logout` is discarded and sign-in loops forever.
 *
 * Shared by both design trees — the current and legacy `ProviderAppAuth`/`Navigation` each need the
 * same URI, so it lives here rather than in one of the two providers.
 */
export const getSigninRedirectUri = (): string => {
  const pathname = window.location.pathname === '/logout' ? '/' : window.location.pathname;
  return window.location.origin + pathname + window.location.hash;
};
